import ModalButton from './ModalButton'
import ModalContainer from './ModalContainer'

export default { ModalButton, ModalContainer }



// WEBPACK FOOTER //
// ./src/js/components/modal/index.js